export interface HalLink {
  href: string;
}
